import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { toast } from "sonner";

import { AppShell } from "@/components/app-shell";
import { useAuth } from "@/lib/auth";
import { useI18n } from "@/lib/i18n";

export const Route = createFileRoute("/_app")({
  component: AppLayout,
});

function AppLayout() {
  const { user, ready, sessionExpired } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();

  useEffect(() => {
    if (ready && !user) {
      // Tell the user *why* they are back at the login screen. Before, an expired
      // token just left every screen silently failing with stale data on show.
      if (sessionExpired) toast.info(t("auth.session_expired"));
      navigate({ to: "/auth", search: {} as any });
    }
  }, [ready, user, sessionExpired, navigate, t]);

  if (!ready || !user) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      </div>
    );
  }

  return <AppShell />;
}
